import React from 'react'

import { Col, Form } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const CuentaContableFormGroup = ({ iError, iTouched, iValue, values, setValues }) => {
  const onChange = React.useCallback(
    salida => {
      values.cuentaContable = salida.value
      values.cuentaContableInfo = salida.label
      values.cuentaContableTipoDocumento = salida.tipoDocumento
      values.flagCentroCosto = salida.flagCentroCosto
      values.esCuentaActivoFijo = salida.esActivoFijo
      values.tipoSocio = salida.tipoSocio

      if (!salida.value.startsWith('6') && !salida.value.startsWith('9')) {
        values.tipoAfectacion = ''
      }

      setValues(values)

      setTimeout(() => {
        KeyEventUtil.leaveOnKeyEvent(`input-modalavanz-tipoCambio`)
      }, 200)
    },
    [values, setValues]
  )

  const clickClear = React.useCallback(() => {
    values.cuentaContable = ''
    values.cuentaContableInfo = ''
    values.cuentaContableTipoDocumento = ''
    values.flagCentroCosto = false
    values.esCuentaActivoFijo = false
    values.tipoSocio = ''

    setValues(values)

    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent(`select-modalavanz-cuentaContable`)
    }, 200)
  }, [values, setValues])

  return (
    <Form.Group>
      <Form.Label text='CUENTA CONTABLE' htmlFor={`select-modalavanz-cuentaContable`} md={12} />
      <Col md={12}>
        {iValue ? (
          <ClearInputGroup
            id={`clearinput-modalavanz-cuentaContable`}
            iValue={iValue}
            clickClear={clickClear}
          />
        ) : (
          <Select2CuentaContable
            id={`select-modalavanz-cuentaContable`}
            onlyAnalitica
            onChange={onChange}
          />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableFormGroup)
